export default __webpack_public_path__ + "static/media/XS4 Original+.8946e2b5.jpg";